import { useEffect } from 'react';
import { usePageLoading } from '../contexts/PageLoadingContext';

/**
 * Bridges a component's local loading state to the global page loading bar.
 * Usage: usePageLoadingEffect(loading);
 */
export default function usePageLoadingEffect(isLoading) {
  const { startLoading, stopLoading } = usePageLoading();

  useEffect(() => {
    if (isLoading) {
      startLoading();
      return () => stopLoading();
    }
  }, [isLoading, startLoading, stopLoading]);
}
